/**
 * The sidecar wire format: the tags, and how to read them back.
 *
 * Deliberately free of React and of rrweb. The emitter (./sidecar.js) runs in
 * the app, the reader runs in the viewer, and the round-trip test runs in
 * neither — keeping the shared contract in a plain module means all three agree
 * by construction rather than by two copies staying in sync.
 */

export const SIDECAR_TAGS = {
  page: 'cpt-page',
  message: 'cpt-message',
  api: 'cpt-api',
  emr: 'cpt-emr',
  console: 'cpt-console',
};

/** rrweb's EventType.Custom. Hard-coded to avoid importing rrweb just for a 5. */
const RRWEB_CUSTOM_EVENT = 5;

/**
 * Pull the sidecar streams out of a replay's event array, by tag.
 *
 * Tolerant on purpose: a replay is stitched from chunks that may be missing or
 * truncated, and other rrweb plugins are free to emit custom events of their
 * own — none of that should throw in the one screen a developer opens when
 * something is already broken.
 */
export function extractSidecars(events) {
  const out = { messages: [], api: [], pages: [], emr: [], console: [] };
  if (!Array.isArray(events)) return out;
  for (const event of events) {
    if (!event || event.type !== RRWEB_CUSTOM_EVENT || !event.data) continue;
    const { tag, payload } = event.data;
    // Stamp the timeline position onto the row: the payload knows what happened,
    // only the envelope knows when, and the viewer needs both together.
    const row = { ...(payload || {}), timestamp: event.timestamp };
    if (tag === SIDECAR_TAGS.message) out.messages.push(row);
    else if (tag === SIDECAR_TAGS.api) out.api.push(row);
    else if (tag === SIDECAR_TAGS.page) out.pages.push(row);
    else if (tag === SIDECAR_TAGS.emr) out.emr.push(row);
    else if (tag === SIDECAR_TAGS.console) out.console.push(row);
  }
  return out;
}
